module.exports = __webpack_public_path__ + "static/media/BT.4eddfdc7.png";